/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from "react"
import { QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"
import { queryClient } from "./src/libs/react-query/queryClient"
import LocationContextProvider from "./src/hooks/LocationContext"

export const wrapRootElement = ({ element }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <LocationContextProvider>
        {element}
        <ReactQueryDevtools />
      </LocationContextProvider>
    </QueryClientProvider>
  )
}
